import React from 'react';
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import { importSecrets } from '../api/secrets';

export default function SecretsPage() {
  const [text, setText] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [result, setResult] = React.useState<string | null>(null);
  const [invalidRows, setInvalidRows] = React.useState<any[]>([]);
  const [error, setError] = React.useState<string | null>(null);

  const handleSubmit = async () => {
    setLoading(true);
    setResult(null);
    setError(null);
    try {
      const res = await importSecrets(text);
      setResult(`Imported ${res.count} rows (created: ${res.created}, updated: ${res.updated})`);
      setInvalidRows(res.invalid || []);
    } catch (e: any) {
      setError(e.message || 'Import failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>Secrets Import</Typography>
      <Paper sx={{ p: 2 }}>
        <Typography variant="body1" gutterBottom>
          Paste address/seed tuples (one per line). Either order is accepted; seeds start with S, addresses start with G or M. Comma or space separated.
        </Typography>
        <TextField
          value={text}
          onChange={(e) => setText(e.target.value)}
          multiline
          minRows={10}
          fullWidth
          placeholder="SD... GA...\nSD... GA..."
        />
        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
          <Button variant="contained" onClick={handleSubmit} disabled={loading || !text.trim()}>
            {loading ? <CircularProgress size={20} /> : 'Import'}
          </Button>
          <Button variant="text" onClick={() => setText('')}>Clear</Button>
        </Box>
        {result && <Alert sx={{ mt: 2 }} severity="success">{result}</Alert>}
        {invalidRows.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Alert severity="warning">{invalidRows.length} invalid row(s) were skipped:</Alert>
            <Box component="pre" sx={{ p: 2, bgcolor: '#fff3e0', borderRadius: 1, overflowX: 'auto' }}>
              {invalidRows.map((r) => `line ${r.line}: ${r.error}${r.address ? ` (address ${r.address})` : ''}${r.derived ? ` (derived ${r.derived})` : ''}`).join('\n')}
            </Box>
          </Box>
        )}
        {error && <Alert sx={{ mt: 2 }} severity="error">{error}</Alert>}
      </Paper>
    </Box>
  );
}


